import { FC } from 'react'
import { Label } from '@cargomart/ui'
import {
  alphabetSymbolsAllow,
  compose,
  FieldFormItem,
  FieldMobilePhone,
  maxChar,
  phoneMobileNumberValid,
  required,
  trimRequired
} from 'forms'
import { FieldText } from 'shared/forms'

const name = 'destinationPartner'

const OrderYarcheCreateDestinationPartner: FC = () => {
  const fieldClassName = 'w-full [&>*:first-child]:!text-on-surface [&>*]:!text-on-surface-variant'

  return (
    <>
      <FieldFormItem label={<Label>Телефон</Label>} name={`${name}.contact.phone`}>
        <FieldMobilePhone
          className={fieldClassName}
          name={`${name}.contact.phone`}
          validate={compose(required, phoneMobileNumberValid)}
        />
      </FieldFormItem>

      <div className="grid grid-cols-1 gap-x-2 md:grid-cols-3">
        <FieldFormItem label={<Label>Фамилия</Label>} name={`${name}.contact.lastname`}>
          <FieldText
            className={fieldClassName}
            name={`${name}.contact.lastname`}
            placeholder="Иванов"
            validate={compose(trimRequired, alphabetSymbolsAllow, maxChar(100))}
          />
        </FieldFormItem>
        <FieldFormItem label={<Label>Имя</Label>} name={`${name}.contact.firstname`}>
          <FieldText
            className={fieldClassName}
            name={`${name}.contact.firstname`}
            placeholder="Иван"
            validate={compose(trimRequired, alphabetSymbolsAllow, maxChar(100))}
          />
        </FieldFormItem>
        <FieldFormItem label={<Label>Отчество (при наличии)</Label>} name={`${name}.contact.secondname`}>
          <FieldText
            className={fieldClassName}
            name={`${name}.contact.secondname`}
            validate={compose(alphabetSymbolsAllow, maxChar(100))}
          />
        </FieldFormItem>
      </div>
    </>
  )
}

export default OrderYarcheCreateDestinationPartner
